module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/60_Striped Polo Shirt.png";